import React, { Component, createRef } from 'react';
import Modal from 'react-responsive-modal';

import NavBar from '../../components/navigation/NavBar';
import RateView from '../../components/rateview/RateView';
import ApiResponse from '../../components/message/ApiResponse';

import { getCurrentResource, findByKey, getDefinedItem } from '../../util/tools';
import { canPerformAction } from '../../util/localStorage';

import {
	USER_PROFILE_API_URL, ACTION_PROVIDER_LOAD_AGGREGATOR_LIST_API_URL, 
	ACTION_CREATE_REQUEST_BY_ORDERS_API_URL, performApiRequest 
} from '../../util/restapi';
import { ACTION_CREATE_REQUEST_BY_ORDERS } from '../../util/consts/actions';

import { FORM_ORDER_TABLE } from '../../util/consts/forms';

import iconCreateRequest from '../../assets/icons/png24x24/Accept.png';

const FORM_STATE_GET_DATA = 'd';
const FORM_STATE_WAITING = 'w';
const FORM_STATE_COMPLETE = 'c';

class OrderListPage extends Component {

	constructor(props) {
		super(props);
		this.refRateView = createRef();
		this.refCreateRequestModal = createRef();

		this.resource = getCurrentResource().pages.tableform.OrderList;
		let paramCacheId = props.match.params.param;

		this.rvContext = {
			form: FORM_ORDER_TABLE,
			data: []
		}
		this.rvOptions = {
			form: FORM_ORDER_TABLE,
			formTitle: this.resource.formTitle,
			paramCacheId: paramCacheId,
			controlPanelTools: this.controlPanelTools(),
			transition: null,

			hideButtonAdd: false,
			hideButtonEdit: false,
			hideButtonMergeInstances: true,
			hideButtonChangeOwner: false,
			hideButtonFieldUpdate: false,
			hideButtonGlobalIdUpdate: true,
			hideButtonDelete: false,
			hideButtonShowHtml: false,
			hideButtonHtml: false,
			hideButtonPdf: true,
			hideButtonXml: true,
			//hideButtonTransition: true,
			hideButtonUshExport: false,
			hideButtonUshImport: false,
			hideButtonSendEmail: true,
		};

		this.state = {
			isCreateRequestModalOpen: false,
		}
	}
	componentDidMount() {
		document.title = 'BOM. ' + this.resource.formTitle;
	}
	
	controlPanelTools = () => {
		return (
			<div style={{textAlign: 'left', marginLeft: '20px'}}>
				<ControlPanelButtonCreateRequest holder={this} />
			</div>			
		);
	}
	
	openCreateRequestModal = () => {
		this.refCreateRequestModal.current.init(true);
		this.setState({ isCreateRequestModalOpen: true});	
	}
	closeCreateRequestModal = () => {
		this.setState({ isCreateRequestModalOpen: false });	
	}
	
	render() {
		return (
			<React.Fragment>
				<NavBar app={this.props.app} />
				<RateView ref={this.refRateView} rvContext={this.rvContext} rvOptions={this.rvOptions} app={this.props.app}  />
				<CreateRequestModal ref={this.refCreateRequestModal} page={this} 
					isModalOpen={this.state.isCreateRequestModalOpen} 
					close={this.closeCreateRequestModal} 
				/>
			</React.Fragment>
		)
	}
	
}

function ControlPanelButtonCreateRequest(props) {
	
	if( canPerformAction( ACTION_CREATE_REQUEST_BY_ORDERS ) ) {
		return (
			<button type='button' style={{marginLeft: '5px', width: '36px', height: '30px'}}
				 onClick={props.holder.openCreateRequestModal}
				 title={props.holder.resource.buttonCreateRequestTooltip} 
			>
				<img src={iconCreateRequest} />
			</button>			
		);
	} else {
		return null;
	}
}

class CreateRequestModal extends React.Component {

	constructor(props) {
		super(props);
		this.recipientList = [{id: 0, card: '', email: ''}];
		this.userProfile = null;
		this.apiResponse = { message: '', log: ''};
		this.init(false);
		this.state = {
			dirtyCount: 0,
			formState: FORM_STATE_GET_DATA,
			doSendEmail: true,
		};
	}
	componentDidMount = async () => {
		let response = await performApiRequest( ACTION_PROVIDER_LOAD_AGGREGATOR_LIST_API_URL, {} );
		if( ! response.success ) {
			this.apiResponse = response;
			this.setState({formState: FORM_STATE_COMPLETE});
			return;
		}
		for(let r of response.list) {
			this.recipientList.push( {id: r.refProvider.id, card: r.refProvider.card, email: r.email} );
		}
		
		response = await performApiRequest( USER_PROFILE_API_URL, {} );
		if( ! response.success ) {
			this.apiResponse = response;
			this.setState({formState: FORM_STATE_COMPLETE});
			return;
		}
		this.userProfile = response.data;
		
		this.setState({formState: FORM_STATE_COMPLETE});
	}
	init = (doSetState) => {
		let from = getDefinedItem(this, ['userProfile', 'user', 'contact', 'email'], '');

		this.request = {
			listMarked: [],
			querySelected: null, 
			mode: 'marked',
			supplierId: 0,
			libraryId: 0,
			comment: '',
			doSendEmail: true,
			from: from,
			to: '',
			subject: '',
		}
		this.apiResponse = { message: '', log: ''};

		if( doSetState ) {
			let rateView = this.props.page.refRateView.current;
			this.request.listMarked = rateView.getSelectedIds();
			this.request.querySelected = rateView.query;
			if( this.userProfile && this.userProfile.listLibrary.length > 0) {
				this.request.libraryId = this.userProfile.listLibrary[0].id;
			}
			this.setState({
				dirtyCount: 0,
				formState: FORM_STATE_GET_DATA,
				doSendEmail: true,
			});
		}
	}

	handleInputEdit = (e) => {
		const {name, value} = e.target;
		if( name == 'mode' ) {
			this.request.mode = value;
		} else if( name == 'provider' ) {
			this.request.supplierId = value;
			let provider = findByKey(this.recipientList, 'id', value);
			this.request.to = provider.email;
		} else if( name == 'library' ) {
			this.request.libraryId = value;
		} else if( name == 'to' ) {
			this.request.to = value;
		} else if( name == 'from' ) {
			this.request.from = value;
		} else if( name == 'subject' ) {
			this.request.subject = value;
		} else if( name == 'comment' ) {
			this.request.comment = value;
		} 
		this.setState({dirtyCount: this.state.dirtyCount+1})
	}
	handleCheckBoxClick = (e) => {
		const {name, checked} = e.target;
		if( name == 'doSendEmail') {
			this.request.doSendEmail = checked;
			this.setState({doSendEmail: checked});
		}
	}
		
	createRequest = async () => {
		this.setState({formState: FORM_STATE_WAITING});
		this.apiResponse = await performApiRequest( ACTION_CREATE_REQUEST_BY_ORDERS_API_URL, this.request );
		this.setState({formState: FORM_STATE_COMPLETE});
	}
	
	render() {
		let res = this.props.page.resource;
		let divWaiting = null;
		let divMessage = null;
		let inputDisabled = this.state.formState != FORM_STATE_GET_DATA;
		if( this.state.formState == FORM_STATE_WAITING ) {
			divWaiting = <div style={{textAlign: 'center', padding: '7px'}}>{res.msgWait}</div>
		} else if( this.state.formState == FORM_STATE_COMPLETE ) {
			let defaultMessage = this.apiResponse.success ? res.msgSuccessfullyCreated : res.msgCreateError;
			divMessage = <ApiResponse response={this.apiResponse} defaultMessage={defaultMessage} />
		}
		let listRecipentHtml = this.recipientList.map( (provider, index) => {
			return <option key={index} value={provider.id}>{provider.card}</option>
		} );
		let listLibrariesHtml = null;
		if( this.userProfile ) {
			listLibrariesHtml = this.userProfile.listLibrary.map( (ref, index) => {
				return <option key={index} value={ref.id}>{ref.card}</option>
			} );
		}
		let divEmailHtml = null;
		if( this.state.doSendEmail ) {
			divEmailHtml = (
				<div style={{marginLeft: '20px', marginRight: '15px'}}>
					<div style={{display: 'flex', marginTop: '20px'}}>
						<div style={{marginRight: '10px'}}>{res.labelTo}</div>
						<input type='text' name='to' value={this.request.to} style={{flexGrow: '1'}}  onChange={this.handleInputEdit}/>
					</div>
					<div style={{display: 'flex', marginTop: '20px'}}>
						<div style={{marginRight: '10px'}}>{res.labelFrom}</div>
						<input type='text' name='from' value={this.request.from} style={{flexGrow: '1'}}  onChange={this.handleInputEdit}/>
					</div>
					<div style={{display: 'flex', marginTop: '20px'}}>
						<div style={{marginRight: '10px'}}>{res.labelSubject}</div>
						<input type='text'name='subject' value={this.request.subject} style={{flexGrow: '1'}}  onChange={this.handleInputEdit}/>
					</div>
				</div>
			)
		}
		return (
			<Modal 
				open={this.props.isModalOpen} onClose={this.props.close} center 
				styles={styleModal}
				closeOnOverlayClick={false} animationDuration={1}
			>
				<div>
					<div style={{fontSize: '16pt', textAlign: 'center', padding: '10px', borderRadius: '21px 21px 0 0', backgroundColor: '#F0F0F0'}}>
						{res.modalCreateRequestTitle}
					</div>
					<div style={{marginTop: '10px', padding: '10px'}}>
						<div>
							<span style={{marginRight: '10px'}}>{res.labelMode}</span>
							<select name='mode' value={this.request.mode} onChange={this.handleInputEdit}>
								<option value='marked'>{res.optionMarked}</option>
								<option value='selected'>{res.optionSelected}</option>
							</select>
						</div>
						<div style={{display: 'flex', marginTop: '20px'}}>
							<div style={{marginRight: '10px'}}>{res.labelRecipient}</div>
							<select name='provider' value={this.request.supplierid} onChange={this.handleInputEdit} style={{maxWidth: '320px'}}>
								{listRecipentHtml}
							</select>
						</div>
						<div style={{display: 'flex', marginTop: '20px'}}>
							<div style={{marginRight: '10px'}}>{res.labelLibrary}</div>
							<select name='library' value={this.request.libraryId} onChange={this.handleInputEdit}>
								<option value='0'>&nbsp;</option>
								{listLibrariesHtml}
							</select>
						</div>
						<div style={{marginTop: '20px'}}>
							<div>{res.labelComment}</div>
							<textarea name="comment" rows="4" cols="60" onChange={this.handleInputEdit}>{this.request.comment}</textarea>
						</div>
						<div style={{marginTop: '20px'}}>
							<input type='checkbox' name='doSendEmail' onChange={this.handleCheckBoxClick} checked={this.state.doSendEmail}/>
							<span style={{marginLeft: '7px'}}>{res.labelSendEmail}</span>
						</div>
						{divEmailHtml}
					</div>
					{divWaiting}
					{divMessage}
					<div style={{marginTop: '7px', padding: '10px', marginRight: '15px', textAlign: 'right'}}>
						<button onClick={this.createRequest} disabled={inputDisabled} title={res.buttonCreateTooltip}>{res.buttonCreate}</button>
					</div>
				</div>
			</Modal>
		);
	}
}

const styleModal = {
	modal: {
		background: '#ffffff',
		padding: '0px',
		borderRadius: '21px',
		maxWidth: '500px',
		width: '100%',
	},
	closeButton: {
		top: '10px',
		right: '10px',
		fill: '#FF0000',
		outline: 'none',
	},
};

export default OrderListPage;
